import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function BreakdownRootCause(props) {
    const { t } = useTranslation("translation");
    return (
        <Autocomplete
            multiple
            id="bl_table_Autocomplete_11"
            options={props.breakdownRootCauseData}
            limitTags={5}
            value={props.breakdownRootCauseData.filter((item) => props.breakdownRootCause?.includes(item.id))}
            disableCloseOnSelect
            getOptionLabel={(option) => option.breakdownRootCauseLocalizationName ?? option.name}
            renderInput={(params) => <TextField id="bl_table_TextField_11" {...params} margin="normal" label={t("BreakdownRootCause")} variant="outlined" size="small" />}
            onChange={(event, newValue) => {
                props.HandleBreakdownRootCause(newValue);
            }}
            renderOption={(_props, option) => <li {..._props}>{option.breakdownRootCauseLocalizationName ?? option.name}</li>}
            size={props.size ?? "normal"}
        />
    );
}
